import React, { useContext } from 'react'
import { CrossOutlined } from 'chemistry'
import { TranslateContext } from '../../../../common/translator'

const DrawerHeader = ({ onClose, title }) => {
  const t = useContext(TranslateContext)
  return (
    <div className='drawer-category-header flex gap-12 items-center justify-between'>
      <h3>{title}</h3>
      <button className='flex items-center' onClick={onClose}>
        <CrossOutlined />
        {t('lister.buyList.close')}
      </button>
    </div>
  )
}

export default DrawerHeader
